import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { APPLICATIONS } from '../data/content';
import './Applications.css';

export default function Applications() {
  const { t, lang } = useLanguage();
  const items = APPLICATIONS[lang];

  return (
    <section id="applications" className="section applications">
      <div className="container">
        <div className="section-head section-head--center">
          <span className="kicker">{t.applications.kicker}</span>
          <h2 className="section-title">{t.applications.title}</h2>
          <p className="applications__intro">{t.applications.intro}</p>
        </div>
        <div className="applications__grid">
          {items.map((item, i) => (
            <div className="application-chip" key={i}>
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
